import {
  MDBAlert,
  MDBBreadcrumb,
  MDBBreadcrumbItem,
  MDBBtn,
  MDBCol,
  MDBDatatable,
  MDBIcon,
  MDBModal,
  MDBModalBody,
  MDBModalContent,
  MDBModalDialog,
  MDBModalHeader,
  MDBModalTitle,
  MDBRow,
  MDBScrollspy,
  MDBScrollspyLink,
  MDBSpinner,
  MDBTabs,
  MDBTabsContent,
  MDBTabsItem,
  MDBTabsLink,
  MDBTabsPane,
} from "mdb-react-ui-kit";
import React, { useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
// import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router";
import { Tooltip } from "react-tooltip";
import {
  editUser,
  getMisc,
  getSpecificUsers,
} from "../../../apiclients/streamsapi_bridge";
import UserUpdateWarnings from "../../../views/popups/users/UserUpdateWarnings";
import Body from "../../body/BodyPage";
import TopMessage from "../../header/TopMessage";
import TopSuccess from "../../header/TopSuccess";
import MainLinks from "../../navlinks/MainLinks";
import SaveChanges from "../../topviews/saveCancel";
import CallingandSMS from "./CallingandSMS";
import ConferenceBridge from "./ConferenceBridge";
import GeneralSettings from "./GeneralSettings";
import Integrations from "./Integrations";
import StreamsSettings from "./StreamsSettings";
import UserAddons from "./UserAddons";
import UserCallRecording from "./UserCallRecording";
import UserCallRouting from "./UserCallRouting";
import UserExternalNumbers from "./UserExternalNumbers";
import UserFax from "./UserFax";
import UserGroup from "./UserGroup";
import UserIpPhonesDevices from "./UserIpPhonesDevices";
import UserSmartboxSettings from "./UserSmartboxSettings";
import UserVoicemails from "./UserVoicemail";
import { defaultUImg } from "../../images";
import { useAdminContext } from "../../adminstore/Admin-Context";
import EditWarning from "../../header/EditWarning";
import { useTranslation } from "react-i18next";
import UIConstant from "../../../apiclients/UIConstant";
import { show_links_tab } from "../../../apiclients/apiurls";
import { isFiveNineAccount } from "../../../views/Login";
import { getImpExpStatusNew, getStreamsProductName } from "../../../apiclients/CommonUtils";
import MobileCallAssignments from "./MobileCallAssgnments";
import UserSpamSettings from "./UserSpamSettings";
import ImportProgressWarning from "../../../apiclients/ImportProgressWarning";
import ImpExpRedirectPopup from "../../../apiclients/ImpExpRedirectPopup";
import ImportUser from "./ImportUser";
//import { use } from "i18next";

export default function UserEditMain(props) {
  const section1 = useRef(null);
  const section2 = useRef(null);
  const section3 = useRef(null);
  const section4 = useRef(null);
  const section5 = useRef(null);
  const section6 = useRef(null);
  const section7 = useRef(null);
  const section8 = useRef(null);
  const section9 = useRef(null);
  const section10 = useRef(null);
  const section11 = useRef(null);
  const section12 = useRef(null);
  const section13 = useRef(null);
  const section14 = useRef(null);
  const { isEdited, setEdited } = useAdminContext();
  const [targetView, setTargetView] = useState("");
  const [showWarning, setShowWarning] = useState(false);
  const warningToggle = () => setShowWarning(!showWarning);
  const [showExportWarning, setShowExportWarning] = useState(false);
  const exportwarningToggle = () => setShowExportWarning(!showExportWarning);
  const [warningMessage, setWarningMessage] = useState("");
  const [showImpExpRedirect, setShowImpExpRedirect] = useState(false);
  const [importUser, setimportUser] = useState(false);
  const importuserToggle = () => setimportUser(!importUser);
  const [firstRequest, setfirstRequest] = useState(false);
  const [enableScrollSpy, setEnableScrollSpy] = useState(true);

  const containerRef = useRef(null);

  const refMapping = {
    0: section1,
    1: section2,
    2: section3,
    3: section4,
    4: section5,
    5: section6,
    6: section7,
    7: section8,
    8: section9,
    9: section10,
    10: section11,
    11: section12,
    12: section13,
    13: section14
  };

  const location = useLocation();
  const stateData = location?.state;
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const gref = useRef(null);
  const { state: locationState } = useLocation();
  const [userBInfo, setUserBInfo] = useState(stateData?.selMember || "");
  const [preuserBInfo, setPreUserBInfo] = useState(
    stateData?.previousUser || ""
  );
  const [nextuserBInfo, setNextUserBInfo] = useState(stateData?.nextUser || "");
  const [users, setUsers] = useState(stateData?.users || "");
  const [activeView, setaActiveView] = useState("tab1");
  const [activeTab, setaActiveTab] = useState("tab1");
  const [gSettings, setGsettings] = useState();
  const [addExternalNumbers, setAddExternalNumbers] = useState(false);
  const toggleExtNumbers = () => setAddExternalNumbers(!addExternalNumbers);
  const [addSpeedDial, setAddSpeedDial] = useState(false);
  const [username, setUserName] = useState("");
  const [usrextension, setUsrExtension] = useState("");
  const [usremail, setUsrEmail] = useState("");
  const toggleSpeedDials = () => setAddSpeedDial(!addSpeedDial);
  const [confPhoneNum, setConfPhoneNum] = useState([]);
  const [faxPhoneNum, setFaxPhoneNum] = useState([]);
  const [userserviceid, setUserServiceid] = useState(0);
  // const [ismodify, setIsModify] = useState(false);
  // const [stopfatching, setStopFetching] = useState(true);
  const [useragent, setUserAgent] = useState("");
  const [CallRecording, setCallRecording] = useState(false);
  const [isSmartBox, setIsSmartBox] = useState(false);
  const [smsPhoneNum, setSMSPhoneNum] = useState([]);
  const [callingpermissions, setCallingPermission] = useState([]);
  const [usercallerid, setUserCallerId] = useState([]);
  const [vmailFormats, setVmailFormats] = useState(0);
  const [vmailpin, setVmailPin] = useState(0);
  const [timezone, setTimeZone] = useState(0);
  const [mobilecallpref, setMobileCallPref] = useState({});
  const [autociddisplay, setAutoCIDDisplay] = useState(false);
  const [externalNumbers, setExternalNumbers] = useState([]);
  const [usergroups, setUserGroup] = useState([]);
  const [accCallRecord, setAccCallRecord] = useState([]);
  const [rerender, setRerender] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [message, setMessage] = useState([]);
  const [checkAvailable, setCheckAvailable] = useState(false);
  const [greetingInfo, setGreetingInfo] = useState(null);
  const [isloading, setIsloading] = useState(false);
  const [isDisabled, setIsDisabled] = useState(false);
  const [userAddons, setUserAddons] = useState([]);
  const [existPurchased, setExistPurchased] = useState([]);
  const [existAvailable, setExistAvailable] = useState([]);
  const [internalError, setInternalError] = useState(false);
  const [userRoles, setuserRoles] = useState([]);
  const [sectionList, setsectionList] = useState([]);
  const [fields, setfields] = useState([]);
  const [links, setlinks] = useState([]);
  const [callPermit, setCallPermit] = useState([]);
  const [warningsList, setwarningsList] = useState([]);
  const [modifiedDataJSon, setmodifiedDataJSon] = useState({});
  const [addonsError, setaddonsError] = useState([]);
  const [changePlan, setchangePlan] = useState(false);
  const [faxDomain, setfaxDomain] = useState("");
  const [userDeviceList, setUserDeviceList] = useState([]);
  const [ulmGroupList, setulmGroupList] = useState([]);
  const [allowULMGroup, setallowULMGroup] = useState(false);
  const [assocCallFlows, setAssocCallFlows] = useState([]);
  const [profileImageUrl, setProfileImageUrl] = useState("");
  const [reqFromCallFlow, setreqFromCallFlow] = useState(false);
  const [callAssignment, setCallAssignment] = useState({});
  const [sid, setSid] = useState(false);
  const [faxPhoneError, setfaxPhoneError] = useState(false);
  const [faxEnabledFlag, setfaxEnabledFlag] = useState(false);
  const [recordEnabledFlag, setrecordEnabledFlag] = useState(false);
  // const streamsReq =
  //   JSON.parse(sessionStorage.getItem("admin_session"))?.isStreamReq ?? 0;
  const [userSettingsActive, setuserSettingsActive] = useState(true);
  const [navigateUserFlag, setnavigateUserFlag] = useState(false);
  const [isFiveNineAcc , setisFiveNineAcc] = useState(false);
  const [voicemailEAddress, setvoicemailEAddress] = useState("");
  const streamsProductName = getStreamsProductName();

  useEffect(() => {
    const disabledState = () => {
      const isAdminSession = JSON.parse(
        sessionStorage.getItem("admin_session")
      );
      const isAdmin = isAdminSession?.permissions
        ? !isAdminSession?.permissions.includes(
            UIConstant.ALLOW_ADD_DELETE_EDIT_USER
          ) ||
          !isAdminSession?.permissions.includes(UIConstant.ALLOW_MANAGED_SEAT)
        : false;
      setIsDisabled(isAdmin);
    };
    disabledState();
  }, []);

  useEffect(() => {
    if (errorMessage) {
      setTimeout(() => {
        setErrorMessage(""); // Clear the error message in the parent component
      }, 5000);
    }
  }, [errorMessage]);

  useEffect(() => {
    if (successMessage) {
      setMessage(true);
      setTimeout(() => {
        setMessage(false);
        setSuccessMessage(""); // Clear the success message in the parent component
      }, 5000);
    }
  }, [successMessage]);

  const modifytheState = (e, email) => {
    e.preventDefault();
    let selMember = users.filter((tmdata) => tmdata.email == email)[0];
    const currentIndex = users.findIndex((tmdata) => tmdata.email == email);
    const previousUser = currentIndex > 0 ? users[currentIndex - 1] : null;
    const nextUser =
      currentIndex < users.length - 1 ? users[currentIndex + 1] : null;
    setUserBInfo(selMember);
    setPreUserBInfo(previousUser);
    setNextUserBInfo(nextUser);
    setnavigateUserFlag(true);
  };
  const [defaultValuess, setDefaultValuess] = useState({});

  useEffect(() => {
    //if (userBInfo.agentid) {
      setisFiveNineAcc(isFiveNineAccount());
      let fivenineac = isFiveNineAccount();
    async function fetchSpecificData() {
      try {
        setIsloading(true);
        const response = await getSpecificUsers(
          JSON.parse(sessionStorage.getItem("admin_session")).siteid,
          userBInfo.agentid
        );
        setTimeout(() => {
          setIsloading(false);
        }, 1000);
        // alert("verifying .....");
        const rawData = await response.json();
        console.log("rawData ::::::::: " + JSON.stringify(rawData));
        let userdetails = rawData.users[0];
        console.log("getSpecific User ::: " + JSON.stringify(userdetails));
        // alert("getSpecific User ::: " + JSON.stringify(userdetails));
        setUserAgent(userBInfo.agentid);
        setUserBInfo(userdetails);
        setUserName(userdetails.fname + " " + userdetails.lname);
        setUsrExtension(userdetails.extension);
        setUsrEmail(userdetails.email);
        setGreetingInfo(userdetails.greetings);
        setSid(userdetails.sid);
        setAssocCallFlows(userdetails.associated_callflows);
        setAutoCIDDisplay(
          userdetails.automatic_local_cid?.automatic_cid_display
            ? userdetails.automatic_local_cid.automatic_cid_display
            : false
        );
        setFaxPhoneNum(userdetails.fax?.fax_dids ?? []);
        setfaxDomain(userdetails.fax?.faxemaildomain ?? "");
        setConfPhoneNum(
          userdetails.conference?.ph_numbers
            ? userdetails.conference.ph_numbers
            : []
        );
        setUserGroup(userdetails?.groups ?? []);
        setExternalNumbers(
          userdetails.external_ph_num ? userdetails.external_ph_num : []
        );
        setUserServiceid(userdetails.serviceid);
        setSMSPhoneNum(userdetails.ph_numbers ? userdetails.ph_numbers : []);
        setCallingPermission(
          userdetails.calling_permissions ? userdetails.calling_permissions : 0
        );
        setAccCallRecord(
          userdetails?.call_rec?.users_permit_access_call_rec
            ? parseInt(userdetails.call_rec.users_permit_access_call_rec)
            : 0
        );
        setUserCallerId(userdetails.callerid ? userdetails.callerid : "");
        setVmailFormats(
          userdetails.voice_mail?.vml_format
            ? parseInt(userdetails.voice_mail.vml_format)
            : 0
        );
        setVmailPin(
          userdetails.voice_mail?.vmail_pin
            ? userdetails.voice_mail.vmail_pin
            : ""
        );
        setTimeZone(userdetails.tzid ? parseInt(userdetails.tzid) : 0);
        setMobileCallPref({
          one:
            userdetails?.mobile_call_pref?.one != undefined
              ? parseInt(userdetails.mobile_call_pref.one)
              : -1,
          two:
            userdetails.mobile_call_pref?.two != undefined
              ? parseInt(userdetails.mobile_call_pref.two)
              : -1,
          three:
            userdetails.mobile_call_pref?.three != undefined
              ? parseInt(userdetails.mobile_call_pref.three)
              : -1,
          four:
            userdetails.mobile_call_pref?.four != undefined
              ? parseInt(userdetails.mobile_call_pref.four)
              : -1,
        });

        setUserAddons(userdetails?.addons ?? []);
        let purchased = [];
        let available = [];
        const alladdons = userdetails?.addons;
        if (alladdons && alladdons.length > 0) {
          alladdons.map((addon) => {
            if (addon.purchased) {
              purchased.push(parseInt(addon.fid));
            } else {
              available.push(parseInt(addon.fid));
            }
          });
        }
        setExistPurchased(purchased);
        setExistAvailable(available);
        setuserRoles(userdetails?.role ?? []);
        let sectionarr = userdetails?.privileges?.sections ?? [];
        sectionarr = fivenineac
        ? sectionarr.filter(sc => sc.name === 'General' && sc.link_id === 1)
        : sectionarr;
        sectionarr = sectionarr.map((sec, index) => ({
          ...sec,
          uniqueVal: parseInt(index),
        }));
        setsectionList(sectionarr.filter((sec) => sec.id !== 92));
        setfields(userdetails?.privileges?.fields ?? []);
        const linkDetails = userdetails?.privileges?.links ?? [];

        const filteredLinks = fivenineac
          ? linkDetails.filter(s => s.name !== streamsProductName && s.name !== "Call Routing" && s.name !== "Integrations")
          : linkDetails;
        
        setlinks(filteredLinks);
        const currentTabMatch = linkDetails.some(
          (link) => link.id && "tab" + link.id === activeView
        );
        if (!currentTabMatch) {
          setaActiveView("tab1");
        }
        setUserDeviceList(userdetails?.device_details ?? []);
        setulmGroupList(userdetails?.ulm_groups?.groups ?? []);
        setallowULMGroup(
          userdetails?.ulm_groups?.ulm_group_visibility ?? false
        );
        setProfileImageUrl(
          userdetails?.profile_pic_link && userdetails?.profile_pic_link !== ""
            ? userdetails?.profile_pic_link
            : defaultUImg
        );
        setfaxEnabledFlag(
          userdetails?.fax?.name && userdetails?.fax?.name !== "" ? true : false
        );
        setrecordEnabledFlag(
          userdetails?.call_rec?.enable_call_rec
            ? userdetails.call_rec.enable_call_rec
            : false
        );
        setvoicemailEAddress(userdetails?.voice_mail?.email_address ?? userdetails.email); 
        reset({
          fname: userdetails?.fname ?? "",
          lname: userdetails?.lname ?? "",
          extension: userdetails?.extension
            ? parseInt(userdetails.extension)
            : 0,
          emailid: userdetails?.email ?? "",
          term: 0,
          autoassign: false,
          seatplan_info: {
            serviceid: userdetails.serviceid
              ? parseInt(userdetails.serviceid)
              : 0,
            added_addons: [],
          },
          // serviceid: userdetails.serviceid
          //   ? parseInt(userdetails.serviceid)
          //   : 0,
          added_dids: [],
          removed_dids: [],
          caller_id: userdetails.callerid ? userdetails.callerid : "",
          tzid: userdetails.tzid ? parseInt(userdetails.tzid) : 0,
          manage_cid:
            userdetails.manage_cid && parseInt(userdetails.manage_cid) === 1
              ? true
              : false,
          automatic_local_cid: userdetails.automatic_local_cid
            ?.automatic_local_cid
            ? userdetails.automatic_local_cid.automatic_local_cid
            : false,
          disable_cid:
            userdetails.disable_cid && parseInt(userdetails.disable_cid) === 1
              ? true
              : false,
          sms_enabled:
            userdetails.sms_enabled && parseInt(userdetails.sms_enabled) === 1
              ? true
              : false,
          sms_def_num: userdetails.sms_def_num
            ? userdetails.sms_def_num?.toString()
            : "",
          allow_user_set_spam: userdetails.allow_user_set_spam
            ? parseInt(userdetails.allow_user_set_spam)
            : 4,
          conf_flag: userdetails?.conference?.name ? true : false,
          calling_permissions: userdetails.calling_permissions
            ? userdetails.calling_permissions
            : 0,
          ctc: userdetails.ctc != undefined ? parseInt(userdetails.ctc) : 6,
          mobile_call_pref: {
            one:
              userdetails?.mobile_call_pref?.one != undefined
                ? parseInt(userdetails.mobile_call_pref.one)
                : -1,
            two:
              userdetails.mobile_call_pref?.two != undefined
                ? parseInt(userdetails.mobile_call_pref.two)
                : -1,
            three:
              userdetails.mobile_call_pref?.three != undefined
                ? parseInt(userdetails.mobile_call_pref.three)
                : -1,
            four:
              userdetails.mobile_call_pref?.four != undefined
                ? parseInt(userdetails.mobile_call_pref.four)
                : -1,
          },
          fax_enable:
            userdetails?.fax?.name && userdetails?.fax?.name !== ""
              ? true
              : false,
          fax: {
            name: userdetails?.fax?.name ?? "",
            email: userdetails?.fax?.email ?? "",
            primary_did: userdetails?.fax?.primary_did ?? "",
            add_dids: [],
            remove_dids: [],
          },
          conference: {
            name: userdetails.conference?.name
              ? userdetails.conference.name
              : "",
            pin: userdetails.conference?.pin
              ? parseInt(userdetails.conference.pin)
              : "",
            extension: userdetails.conference?.extension
              ? parseInt(userdetails.conference.extension)
              : "",
            adddids: [],
            removedids: [],
          },
          smart_box: {
            enable_smart_box: userdetails?.smart_box?.enable_smart_box ?? false,
            acc_sharing: userdetails?.smart_box?.acc_sharing ?? false,
            local_client: userdetails?.smart_box?.local_client ?? false,
            mobile_client: userdetails?.smart_box?.mobile_client ?? false,
          },
          voice_mail: {
            vmlformat: userdetails.voice_mail?.vml_format
              ? parseInt(userdetails.voice_mail.vml_format)
              : 0,
            vmail_active:
              userdetails.voice_mail?.vmail_active !== undefined
                ? userdetails.voice_mail.vmail_active
                : false,
            vmail_delete: userdetails.voice_mail?.vmail_delete,
            announcertime:
              userdetails.voice_mail?.announcertime !== undefined
                ? userdetails.voice_mail.announcertime
                : false,
            email_transcript: userdetails?.voice_mail?.email_transcript ?? true,
            vmail_pin: userdetails.voice_mail?.vmail_pin
              ? userdetails.voice_mail.vmail_pin
              : "",
            email_address:
              userdetails?.voice_mail?.email_address ?? userdetails.email,
          },
          groups: {
            added_groups: [],
            removed_groups: [],
          },
          ulm_groups: {
            ulmaccess: userdetails?.ulm_groups?.ulmaccess ?? false,
            includeinucc: userdetails?.ulm_groups?.includeinucc ?? false,
            // independentulm: userdetails?.ulm_groups?.independentulm ?? false,

            groups: [],
          },

          call_rec: {
            enable_call_rec: userdetails?.call_rec?.enable_call_rec
              ? userdetails.call_rec.enable_call_rec
              : false,
            allow_user_edit_call_rec: userdetails?.call_rec
              ?.allow_user_edit_call_rec
              ? userdetails.call_rec.allow_user_edit_call_rec
              : false,
            record_all_calls: userdetails?.call_rec?.record_all_calls
              ? userdetails.call_rec.record_all_calls
              : false,
            record_outbound_calls: userdetails?.call_rec?.record_outbound_calls
              ? userdetails.call_rec.record_outbound_calls
              : false,
            record_inbound_calls: userdetails?.call_rec?.record_inbound_calls
              ? userdetails.call_rec.record_inbound_calls
              : false,
            record_all_int_calls: userdetails?.call_rec?.record_all_int_calls
              ? userdetails.call_rec.record_all_int_calls
              : false,
            play_call_rec_beep: userdetails?.call_rec?.play_call_rec_beep
              ? userdetails.call_rec.play_call_rec_beep
              : false,
            users_permit_access_call_rec: userdetails?.call_rec
              ?.users_permit_access_call_rec
              ? parseInt(userdetails.call_rec.users_permit_access_call_rec)
              : false,
          },
          addons: {
            added_addons: [],
            removed_addons: [],
          },
          loc_id: userdetails?.loc_id[0]?.id
            ? parseInt(userdetails.loc_id[0].id)
            : 0,
          billing_grp: userdetails?.billing_grp[0]?.group_id
            ? parseInt(userdetails?.billing_grp[0]?.group_id)
            : 0,
        });
        setEnableScrollSpy(true);
        setRerender(false);
      } catch (error) {
        console.log(error + "Error in get specific request of user details");
        //alert(error);
      }
    }
    if (
      (userBInfo.agentid || rerender) &&
      (userSettingsActive || navigateUserFlag)
    ) {
      fetchSpecificData();
      setnavigateUserFlag(false);
    }
    //}
  }, [userBInfo.agentid, userSettingsActive, rerender, navigateUserFlag]);

  // useEffect(() => {
  //   if (Object.keys(defaultValuess).length !== 0) reset(defaultValuess);
  // }, [defaultValuess]);

  const {
    register,
    handleSubmit,
    formState,
    setValue,
    setError,
    setFocus,
    reset,
    getValues,
    watch,
    control,
    clearErrors,
  } = useForm({
    defaultValues: {
      fname: "",
      lname: "",
      extension: 0,
      emailid: "",
      term: 0,
      autoassign: false,
      // serviceid: 0,
      seatplan_info: {
        serviceid: 0,
      },
      added_dids: [],
      removed_dids: [],
      ctc: 6,
      caller_id: "",
      manage_cid: false,
      automatic_local_cid: false,
      disable_cid: false,
      sms_enabled: false,
      sms_def_num: "",
      allow_user_set_spam: 4,
      conf_flag: false,
      calling_permissions: 0,
      tzid: 0,
      fax_enable: false,
      fax: {
        name: "",
        email: "",
        primary_did: "",
        add_dids: [],
        remove_dids: [],
      },
      conference: {
        name: "",
        pin: 0,
        extension: 0,
        adddids: [],
        removedids: [],
      },
      smart_box: {
        enable_smart_box: false,
        acc_sharing: true,
        local_client: true,
        mobile_client: true,
      },
      voice_mail: {
        vmlformat: 0,
        vmail_active: false,
        vmail_delete: false,
        announcertime: false,
        vmail_pin: 0,
        email_address: "",
        email_transcript: true,
      },
      mobile_call_pref: {
        one: -1,
        two: -1,
        three: -1,
        four: -1,
      },
      groups: {
        added_groups: [],
        removed_groups: [],
      },
      ulm_groups: {
        ulmaccess: false,
        includeinucc: false,
        independentulm: false,
        groups: [],
      },
      call_rec: {
        enable_call_rec: false,
        allow_user_edit_call_rec: false,
        record_all_calls: false,
        record_outbound_calls: false,
        record_inbound_calls: false,
        record_all_int_calls: false,
        play_call_rec_beep: false,
        users_permit_access_call_rec: 0,
      },
      addons: {
        added_addons: [],
        removed_addons: [],
      },
      loc_id: 0,
      billing_grp: 0,
    },
  });
  const { isDirty, errors } = formState;
  const isdirtyFields =
    Object.keys(formState.dirtyFields).length === 0 ? false : true;
  //alert(isdirtyFields + " ::: isdirtyFields");

  const handleExportUserAndSubmit = async () => {
    const result = await getImpExpStatusNew();
    if (result.status === 0) {
      handleSubmit(onSubmit)();
    } else if (result.isOwnUser) {
      setShowImpExpRedirect(true);
    } else {
      const { userInfo } = result;
      if (userInfo?.isaccount) {
        setWarningMessage(t("imp_exp_account_progress", { name: userInfo.name ?? "" }));
      } else {
        setWarningMessage(t("imp_exp_other_user_progress", { name: userInfo?.name ?? "" }));
      }
      exportwarningToggle();
    }
  }

  const onSubmit = async (data) => {
    setmodifiedDataJSon({});
    const modifiedData = prepareJSONRequest(data, formState.dirtyFields);
    console.log("modifiedData :::::::: " + JSON.stringify(modifiedData));
    await sendAPIRequest(modifiedData);
  };

  const sendAPIRequest = async (modifiedData) => {
    setInternalError(false);
    setCheckAvailable(false);
    setwarningsList([]);
    if (modifiedData) {
      setIsloading(true);
      let saverep = await editUser(modifiedData);
      //debugger;
      console.log(`reponse of Edit user :::: ${JSON.stringify(saverep)}`);
      let saverepeMsg = await saverep.json();
      console.log(
        "response of modified data :::" + JSON.stringify(saverepeMsg)
      );
      setTimeout(() => {
        setIsloading(false);
      }, 1000);
      if (saverepeMsg.status && saverepeMsg.status == "success") {
        // reset();
        setmodifiedDataJSon({});
        setRerender(true);
        setSuccessMessage(saverepeMsg.message);
        if (reqFromCallFlow) {
          if (window.opener && window.opener?.receiveMessageFromAAChild) {
            window.opener.receiveMessageFromAAChild(1); // Send a message to the parent
          }
          setreqFromCallFlow(false);
          window.close();
        }
      } else {
        if (saverepeMsg.message?.errors) {
          if (
            saverepeMsg.message?.errors[0].errors &&
            saverepeMsg.message?.errors[0].errors.length > 0
          ) {
            let addonerr = [];
            saverepeMsg.message.errors[0].errors.forEach((err) => {
              if (!err.param_name) {
                addonerr.push(err);
              } else {
                if (err.param_name === "logined_user") {
                  setErrorMessage(err.message);
                }
                if (err.param_name === "fax.add_dids") {
                  setfaxPhoneError(true);
                }
                setError(err.param_name, {
                  type: "server",
                  message: err.message,
                });
              }
              const fieldElement = document.querySelector(
                `input[name="${err.param_name}"]`
              );
              if (fieldElement) {
                fieldElement.focus();
                fieldElement.scrollIntoView({ behavior: "smooth" });
              }
            });
            if (addonerr.length > 0) {
              setaddonsError(addonerr);
            }
          } else if (
            saverepeMsg.message?.errors[0].warnings &&
            saverepeMsg.message?.errors[0].warnings.length > 0
          ) {
            setmodifiedDataJSon(modifiedData);
            setwarningsList(saverepeMsg.message?.errors[0].warnings);
            toggleOpen();
          }
        } else {
          setInternalError(true);
        }
      }
    }
  };

  // function prepareFinalJson(dirtyFields, data) {
  //   const modifiedData = {};
  //   function recurse(dirtyFields, data, modifiedData) {
  //     for (const field of Object.keys(dirtyFields)) {
  //       if (dirtyFields[field] && data.hasOwnProperty(field)) {
  //         if (typeof data[field] === "object" && !Array.isArray(data[field])) {
  //           modifiedData[field] = {};
  //           recurse(dirtyFields[field], data[field], modifiedData[field]);
  //         } else {
  //           modifiedData[field] = data[field];
  //         }
  //       }
  //     }
  //   }
  //   recurse(dirtyFields, data, modifiedData);
  //   return modifiedData;
  // }

  function prepareFinalJson(dirtyFields, data) {
    const modifiedData = {};

    function recurse(dirtyFields, data, modifiedData, path = "") {
      for (const field of Object.keys(dirtyFields)) {
        if (dirtyFields[field] && data.hasOwnProperty(field)) {
          const currentPath = path ? `${path}.${field}` : field;

          if (typeof data[field] === "object" && !Array.isArray(data[field])) {
            modifiedData[field] = {};
            recurse(
              dirtyFields[field],
              data[field],
              modifiedData[field],
              currentPath
            );
          } else if (
            Array.isArray(data[field]) &&
            Array.isArray(dirtyFields[field]) &&
            currentPath === "ulm_groups.groups"
          ) {
            // Special handling for `ulm_groups.groups`
            modifiedData[field] = data[field]
              .map((item, index) => {
                if (dirtyFields[field][index]?.value) {
                  return {
                    code: item.code, // Explicitly include `code`
                    value: item.value, // Include only `value` if modified
                  };
                }
                return null;
              })
              .filter((item) => item !== null); // Remove unmodified items
          } else if (
            Array.isArray(data[field]) &&
            Array.isArray(dirtyFields[field])
          ) {
            // General handling for other arrays
            modifiedData[field] = data[field].filter(
              (_, index) => dirtyFields[field][index]
            );
          } else {
            modifiedData[field] = data[field];
          }
        }
      }
    }

    recurse(dirtyFields, data, modifiedData);
    return modifiedData;
  }

  const prepareJSONRequest = (data, dirtyFields) => {
    // const dirtyFields = formState.dirtyFields;
    console.log("data ::::::::::: " + JSON.stringify(data));
    console.log("dirtyFields ::::::::::: " + JSON.stringify(dirtyFields));
    const modifiedData = prepareFinalJson(dirtyFields, data);
    if (modifiedData) {
      if (modifiedData.call_rec?.enable_call_rec !== undefined) {
        modifiedData.call_rec.allow_user_edit_call_rec = data.call_rec.allow_user_edit_call_rec;
      }
      modifiedData.reqid = 3;
      modifiedData.siteid = JSON.parse(
        sessionStorage.getItem("admin_session")
      ).siteid;
      modifiedData.agentid = userBInfo.agentid;
      modifiedData.logined_user = JSON.parse(
        sessionStorage.getItem("admin_session")
      ).logined_user;
      console.log("modified data for user :::" + JSON.stringify(modifiedData));
      console.log(JSON.stringify(modifiedData));
    }
    return modifiedData;
  };

  function closeSave(e) {
    e.preventDefault();
    // reset();
    setUserBInfo(userBInfo);
    setPreUserBInfo(preuserBInfo);
    setNextUserBInfo(nextuserBInfo);
    setRerender(true);
    setchangePlan(true);
    setEnableScrollSpy(false);
  }
  const setView = (value) => {
    if (value === activeView) {
      return;
    } else if (isEdited) {
      setTargetView(value);
      setShowWarning(true);
      return;
    }
    setaActiveView(value);
    if (value === "tab1") {
      setuserSettingsActive(true);
    } else {
      setuserSettingsActive(false);
    }
  };

  const handleOk = () => {
    setEdited(false);
    reset();
    if (targetView.indexOf("/") !== -1) {
      navigate(targetView);
    } else {
      setaActiveView(targetView);
    }
    setShowWarning(false);
  };

  const setTabView = (value) => {
    if (value === activeTab) {
      return;
    }

    setaActiveTab(value);
  };

  useEffect(() => {
    setEdited(isdirtyFields);
  }, [isdirtyFields]);

  const acdQueueData = {
    columns: [
      "Name",
      "Extension",
      "Show ACD Queue",
      "Agent Status - Login or Logout of All Assigned Queues",
      "Assign Default ACD Queues",
    ],
    rows: [],
  };

  async function handleServicePlanChange(serviceId) {
    try {
      setEnableScrollSpy(false);
      const response = await getMisc(
        JSON.parse(sessionStorage.getItem("admin_session")).siteid,
        {
          misc: ["seatplan_info"],
          agentid: useragent,
          service_id: parseInt(serviceId),
        }
      );
      if (!response.json) {
        const message = `An error has occured: ${response.statusText}`;
        return;
      }
      const tdata = await response.json();
      if (!tdata) {
        window.alert(`info with id  not found`);
      }
      console.log(
        "Data ::::::::::::::::::::::::::::::::::::::::::::::: " +
          JSON.stringify(tdata)
      );
      setCallPermit(
        (tdata?.misc?.callingClass ?? []).map((data) => ({
          text: data.classname,
          value: data.id,
        }))
      );
      setUserAddons(tdata?.misc?.service_addons ?? []);
      let purchased = [];
      let available = [];
      const alladdons = tdata?.misc?.service_addons ?? [];
      if (alladdons && alladdons.length > 0) {
        alladdons.map((addon) => {
          if (addon?.purchased) {
            purchased.push(parseInt(addon.fid));
          } else {
            available.push(parseInt(addon.fid));
          }
        });
      }
      setExistPurchased(purchased);
      setExistAvailable(available);
      let sectionarr = tdata?.misc?.sections ?? [];
      sectionarr = sectionarr.map((sec, index) => ({
        ...sec,
        uniqueVal: parseInt(index),
      }));
      setsectionList(sectionarr.filter((sec) => sec.id !== 92));
      console.log(
        "sectionarr ::::::::::::::::::::: " + JSON.stringify(sectionarr)
      );
      setfields(tdata?.misc?.fields ?? []);
      setlinks(tdata?.misc?.links ?? []);
    } catch (error) {
      console.log(error + "Error in handleServicePlanChange");
    } finally {
      setTimeout(() => {
        setEnableScrollSpy(true);
      }, 0);
    }
  }

  useEffect(() =>{
    if (enableScrollSpy && containerRef.current) {
      containerRef.current.scrollTop = 0;
    }
  }, [enableScrollSpy]);

  const getComponentBySectionId = (id) => {
    switch (id) {
      case 3:
        return (
          <GeneralSettings
            register={register}
            setValue={setValue}
            errors={errors}
            userserviceid={userserviceid}
            timezone={timezone}
            externalNumbers={externalNumbers}
            useragent={useragent}
            setSuccessMessage={setSuccessMessage}
            getValues={getValues}
            setError={setError}
            checkAvailable={checkAvailable}
            clearErrors={clearErrors}
            setErrorMessage={setErrorMessage}
            isDisabled={isDisabled}
            fields={fields}
            handleServicePlanChange={handleServicePlanChange}
            setchangePlan={setchangePlan}
            changePlan={changePlan}
            watch={watch}
            isFiveNineAcc = {isFiveNineAcc}
          />
        );
      case 5:
        return (
          <UserGroup
            useragent={useragent}
            usergroups={usergroups}
            register={register}
            getValues={getValues}
            setValue={setValue}
            setSuccessMessage={setSuccessMessage}
            setErrorMessage={setErrorMessage}
            ulmGroupList={ulmGroupList}
            watch={watch}
            control={control}
            reset={reset}
            allowULMGroup={allowULMGroup}
            errors={errors}
            setRerender={setRerender}
          />
        );
      case 7:
        return (
          <UserAddons
            watch={watch}
            getValues={getValues}
            setValue={setValue}
            userAddons={userAddons}
            existPurchased={existPurchased}
            existAvailable={existAvailable}
            addonsError={addonsError}
            setaddonsError={setaddonsError}
            clearErrors={clearErrors}
          />
        );
      case 17:
        return (
          <CallingandSMS
            register={register}
            setValue={setValue}
            errors={errors}
            smsPhoneNum={smsPhoneNum}
            useragent={useragent}
            callingpermissions={callingpermissions}
            usercallerid={usercallerid}
            autociddisplay={autociddisplay}
            setSuccessMessage={setSuccessMessage}
            setErrorMessage={setErrorMessage}
            setCallPermit={setCallPermit}
            callPermit={callPermit}
            watch={watch}
            setIsloading={setIsloading}
            callAssignment={callAssignment}
            setCallAssignment={setCallAssignment}
            sid={sid}
          />
        );
      case 93:
        return (
          <MobileCallAssignments
            setValue={setValue}
            useragent={useragent}
            mobilecallpref={mobilecallpref}
            callAssignment={callAssignment}
            setCallAssignment={setCallAssignment}
            sid={sid}
          />
        );
      case 94:
        return (
          <UserSpamSettings
            setValue={setValue}
            watch={watch}
          />
        );
      case 22:
        return (
          <UserFax
            register={register}
            setValue={setValue}
            errors={errors}
            getValues={getValues}
            setSuccessMessage={setSuccessMessage}
            watch={watch}
            faxPhoneNum={faxPhoneNum}
            useragent={useragent}
            setError={setError}
            clearErrors={clearErrors}
            faxDomain={faxDomain}
            faxPhoneError={faxPhoneError}
            setfaxPhoneError={setfaxPhoneError}
            faxEnabledFlag={faxEnabledFlag}
            setIsloading={setIsloading}
          />
        );
      case 24:
        return (
          <ConferenceBridge
            register={register}
            setValue={setValue}
            errors={errors}
            confPhoneNum={confPhoneNum}
            getValues={getValues}
            setSuccessMessage={setSuccessMessage}
            useragent={useragent}
            setError={setError}
            clearErrors={clearErrors}
            watch={watch}
          />
        );
      case 44:
        return (
          <UserIpPhonesDevices
            useragent={useragent}
            userDeviceList={userDeviceList}
            setUserDeviceList={setUserDeviceList}
          />
        );
      case 57:
        return (
          <UserCallRecording
            register={register}
            setValue={setValue}
            getValues={getValues}
            watch={watch}
            accCallRecord={accCallRecord}
            recordEnabledFlag={recordEnabledFlag}
            setIsloading={setIsloading}
            useragent={useragent}
          />
        );
      case 62:
        return (
          <UserVoicemails
            register={register}
            setValue={setValue}
            errors={errors}
            vmailFormats={vmailFormats}
            vmailpin={vmailpin}
            greetingsInfo={greetingInfo}
            userAgentId={useragent}
            watch={watch}
            clearErrors={clearErrors}
            voicemailEAddress={voicemailEAddress}
          />
        );
      case 65:
        return (
          <UserSmartboxSettings
            register={register}
            setValue={setValue}
            watch={watch}
            errors={errors}
            clearErrors={clearErrors}
          />
        );
      case 91:
        return (
          <UserExternalNumbers
            register={register}
            setValue={setValue}
            errors={errors}
            externalNumbers={externalNumbers}
            useragent={useragent}
            setSuccessMessage={setSuccessMessage}
            getValues={getValues}
            setError={setError}
            clearErrors={clearErrors}
            setErrorMessage={setErrorMessage}
            isDisabled={isDisabled}
            callAssignment={callAssignment}
            setCallAssignment={setCallAssignment}
          />
        );
      default:
        return null;
    }
  };

  const [basicModal, setBasicModal] = useState(false);

  const toggleOpen = () => setBasicModal(!basicModal);

  useEffect(() => {
    const userdetails = localStorage.getItem("userDetailsInfo")
      ? JSON.parse(localStorage.getItem("userDetailsInfo"))
      : null;

    if (userdetails && Object.keys(userdetails).length > 0) {
      setreqFromCallFlow(true);
      setUserBInfo({ agentid: userdetails.code, title: userdetails.title });
      localStorage.removeItem("userDetailsInfo");
    }
  }, []);

  return (
    <>
      {isloading && (
        <>
          <div className="loadingclass">
            <MDBBtn disabled>
              <MDBSpinner size="sm" role="status" tag="span" className="me-2" />
              Loading...
            </MDBBtn>
          </div>
        </>
      )}
      <MainLinks active={3} />
      <Body
        tablinks={3}
        sublink={8}
        content={
          <>
            <section className="userDetails">
              <div className="card card-height">
                <div className="card-header py-3 px-0">
                  <h5 className="mb-0 ">
                    <MDBBreadcrumb>
                      <MDBBreadcrumbItem>
                        <a
                          onClick={(e) => {
                            if (isEdited) {
                              setTargetView("/userlanding");
                              setShowWarning(true);
                              return;
                            }
                            navigate("/userlanding");
                          }}
                        >
                          <strong>{t("users")}</strong>
                        </a>
                      </MDBBreadcrumbItem>
                      <MDBBreadcrumbItem active>
                        <a
                          onClick={(e) => {
                            if (isEdited) {
                              setTargetView("/userlanding");
                              setShowWarning(true);
                              return;
                            }
                            navigate("/userlanding");
                          }}
                        >
                          <strong>{t("users")}</strong>
                        </a>
                      </MDBBreadcrumbItem>
                      <MDBBreadcrumbItem>
                        <a href="">
                          <strong>{username}</strong>
                        </a>
                      </MDBBreadcrumbItem>
                    </MDBBreadcrumb>
                    {!isFiveNineAcc &&
                      <div className="headerbtns">
                        <div className="customtooltip">
                          <MDBBtn
                            size="sm"
                            color="transparent"
                            className={preuserBInfo != null ? "ms-2 " : "ms-2"}
                            disabled={preuserBInfo == null || preuserBInfo === ""}
                            onClick={(e) => modifytheState(e, preuserBInfo.email)}
                          >
                            <i className="fa fa-chevron-left"></i>
                          </MDBBtn>
                          {preuserBInfo != null && preuserBInfo !== "" && (
                            <span className="tooltiptext">
                              Previous:
                              <br />
                              {preuserBInfo != null
                                ? preuserBInfo.fname + " " + preuserBInfo.lname
                                : ""}
                            </span>
                          )}
                        </div>
                        <div className="customtooltip">
                          <MDBBtn
                            size="sm"
                            color="transparent"
                            className={
                              nextuserBInfo != null
                                ? "ms-2 active"
                                : "ms-2 active"
                            }
                            disabled={
                              nextuserBInfo == null || nextuserBInfo === ""
                            }
                            onClick={(e) =>
                              modifytheState(e, nextuserBInfo.email)
                            }
                          >
                            <i className="fa fa-chevron-right"></i>
                          </MDBBtn>
                          {nextuserBInfo != null && nextuserBInfo !== "" && (
                            <span className="tooltiptext">
                              Next:
                              <br />
                              {nextuserBInfo != null
                                ? nextuserBInfo.fname + " " + nextuserBInfo.lname
                                : ""}
                            </span>
                          )}
                        </div>
                      </div>
                    }

                  </h5>
                </div>

                <div className="card-body px-0">
                  <div className="d-flex align-items-center">
                    <div>
                      <div className="user-profilePicture">
                        {/* {show_links_tab == 1 &&
                          < div className="profile-mask">
                            <MDBIcon
                              far
                              icon="edit"
                              color="white"
                              className="fs-5 EditProfile cursor-pointer"
                            />
                            <MDBIcon
                              className="ms-4 fs-5"
                              fas
                              icon="times"
                              color="white RemoveProfile cursor-pointer"
                            />
                          </div>} */}

                        <img
                          src={profileImageUrl}
                          // src="https://images.unsplash.com/photo-1494790108377-be9c29b29330?q=80&w=1000&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8dXNlciUyMHByb2ZpbGV8ZW58MHx8MHx8fDA%3D"
                          alt=""
                        />
                      </div>
                    </div>
                    <div className="ps-3">
                      <div className="userName">
                        <h5 className="fw-600 mt-2 ">{username}</h5>
                        <p className="m-0 d-flex align-items-center">
                          {usremail}{" "}
                          {(usrextension && !isFiveNineAcc) ? (
                              <>
                              <div className="saperator"></div>
                              <span title="Extension">{usrextension}</span>
                            </>
                          ) : null}
                          {(userRoles) && 
                            userRoles.length > 0 &&
                            userRoles.map((role) => (
                              <>
                                <div className="saperator"></div>
                                <div title="Role">{role}</div>
                              </>
                            ))}
                        </p>
                      </div>
                      {/* <div>
                        {assocCallFlows && assocCallFlows?.length > 0 && (
                          <h6 className="mt-2">
                            <strong className="mt-3 mb-0">
                              Associated Call Flow
                            </strong>
                            <p className="mt-2">
                              {assocCallFlows
                                ?.map(
                                  (obj) =>
                                    " " + obj.name + " : " + obj.extension + " "
                                )
                                .toString()}
                            </p>
                          </h6>
                        )}
                      </div> */}
                    </div>
                  </div>

                  <MDBTabs className="mt-2">
                    {
                      // links && show_links_tab === 1 && links.length > 0
                      //   ? links.map(
                      //       (link, index) =>
                      //         link.id !== 5 && (
                      //           <MDBTabsItem key={index}>
                      //             <MDBTabsLink
                      //               onClick={() => setView(`tab${link.id}`)}
                      //               active={activeView === `tab${link.id}`}
                      //             >
                      //               {link.name}
                      //             </MDBTabsLink>
                      //           </MDBTabsItem>
                      //         )
                      //     )
                      //   :
                      links &&
                        links.length > 0 &&
                        links
                          // .filter((l) => l.name != "Integrations")
                          .map(
                            (link, index) =>
                              link.id !== 5 && (
                                <MDBTabsItem key={index}>
                                  <MDBTabsLink
                                    onClick={() => setView(`tab${link.id}`)}
                                    active={activeView === `tab${link.id}`}
                                  >
                                    {link.name}
                                  </MDBTabsLink>
                                </MDBTabsItem>
                              )
                          )
                    }

                    {/* <MDBTabsItem>
                      <MDBTabsLink
                        onClick={() => setView("tab2")}
                        active={activeView === "tab2"}
                      >
                        {t("streams")}
                      </MDBTabsLink>
                    </MDBTabsItem>
                    <MDBTabsItem>
                      <MDBTabsLink
                        onClick={() => setView("tab3")}
                        active={activeView === "tab3"}
                      >
                        {t("callRouting")}
                      </MDBTabsLink>
                    </MDBTabsItem>
                    <MDBTabsItem>
                      <MDBTabsLink
                        onClick={() => setView("tab4")}
                        active={activeView === "tab4"}
                      >
                        {t("integrations")}
                      </MDBTabsLink>
                    </MDBTabsItem>
                    <MDBTabsItem>
                      <MDBTabsLink
                        onClick={() => setView("tab5")}
                        active={activeView === "tab5"}
                      >
                        {t("ACDQueueCP")}
                      </MDBTabsLink>
                    </MDBTabsItem> */}
                  </MDBTabs>

                  <MDBTabsContent>
                    <MDBTabsPane open={activeView === "tab1"}>
                      <MDBRow>
                        <MDBCol
                          size="2"
                          md="2"
                          lg="2"
                          sm="12"
                          className="col-sm-100 pr-0 leftTabs"
                        >
                        {enableScrollSpy && (
                          <MDBScrollspy
                            container={containerRef}
                            defaultActive={section1}
                          >
                            {sectionList.map((section, index) => (
                              <>
                                {refMapping[section.uniqueVal] && (
                                  <MDBScrollspyLink
                                    key={index}
                                    targetRef={refMapping[section.uniqueVal]}
                                    id={section.id}
                                  >
                                    {section.name}
                                  </MDBScrollspyLink>
                                )}
                              </>
                            ))}
                          </MDBScrollspy>
                        )}
                        </MDBCol>

                        <MDBCol
                          size="12"
                          md="10"
                          sm="12"
                          pr-0
                          className="col-sm-100 pr-0 leftTabContent"
                        >
                          <form
                            className={
                              isDisabled
                                ? "disabled-form cursor-notAllowed"
                                : ""
                            }
                            title={
                              isDisabled && "Do not have previlege to edit user"
                            }
                          >
                            <div className="vtabHeight huntgroup ps-2 ">
                              <div className="w-100">
                                <div
                                  id="element"
                                  ref={containerRef}
                                  className="scrollspy-example"
                                >
                                  {sectionList.map((section, index) => (
                                    <>
                                      {getComponentBySectionId(section.id) && (
                                        <>
                                          <section
                                            key={index}
                                            ref={refMapping[section.uniqueVal]}
                                            id={`section-${index + 1}`}
                                          >
                                            {getComponentBySectionId(
                                              section.id
                                            )}
                                          </section>
                                          {index < sectionList.length - 1 && (
                                            <div className="routing-border mt-2"></div>
                                          )}
                                        </>
                                      )}
                                    </>
                                  ))}
                                </div>
                              </div>
                            </div>
                            {isdirtyFields && (
                              <SaveChanges
                                onClose={(e) => closeSave(e)}
                                isdirtyFields={isdirtyFields}
                                onSave={(e) => {
                                  if (
                                    isloading ||
                                    (errors &&
                                      Object.entries(errors).length > 0 &&
                                      !errors.extension &&
                                      !errors?.conference?.extension)
                                  ) {
                                    e.preventDefault();
                                  } else {
                                    e.preventDefault();
                                    handleExportUserAndSubmit();
                                  }
                                }}
                              />
                            )}
                          </form>
                        </MDBCol>
                      </MDBRow>
                    </MDBTabsPane>
                    <MDBTabsPane open={activeView === "tab2"} className="p-0">
                      <div
                        {...(isDisabled
                          ? {
                              title: "User does not have permission to edit",
                              className: "disabled-form cursor-notAllowed",
                              onClick: (e) => {
                                e.preventDefault();
                                e.stopPropagation();
                              },
                            }
                          : {})}
                      >
                        <StreamsSettings
                          useragent={userBInfo.agentid}
                          setEdited={setEdited}
                          isActive={activeView === "tab2" && !navigateUserFlag}
                          isDisabled={isDisabled}
                        />
                      </div>
                    </MDBTabsPane>
                    <MDBTabsPane open={activeView === "tab3"}>
                      {/* <MDBDatatable search data={actionData3} className='mt-2' /> */}

                      <UserCallRouting
                        useragent={userBInfo.agentid}
                        isDisabled={isDisabled}
                        setErrorMessage={setErrorMessage}
                        setRerender={setRerender}
                        // greetingInfo={greetingInfo}
                        setEdited={setEdited}
                        isActive={activeView === "tab3" && !navigateUserFlag}
                      />
                    </MDBTabsPane>
                    <MDBTabsPane open={activeView === "tab4"}>
                      {/* <MDBDatatable search data={actionData3} className='mt-2' /> */}
                      <div
                        {...(isDisabled
                          ? {
                              title: "User does not have permission to edit",
                              className: "disabled-form cursor-notAllowed",
                              onClick: (e) => {
                                e.preventDefault();
                                e.stopPropagation();
                              },
                            }
                          : {})}
                      >
                        <Integrations
                          useragent={userBInfo.agentid}
                          setEdited={setEdited}
                          isActive={activeView === "tab4"}
                          isDisabled={isDisabled}
                        />
                      </div>
                      {/* {isdirtyFields && (
                        <SaveChanges
                          onClose={closeSave}
                          isdirtyFields={isdirtyFields}
                          onSave={(e) => {
                            e.preventDefault();
                            handleSubmit(onSubmit)();
                          }}
                        />
                      )} */}
                    </MDBTabsPane>
                    {/* <MDBTabsPane open={activeView === "tab5"}>
                      <div className="mt-2 acdQueueDatatable">
                        <div className="actionbar"></div>
                        <MDBDatatable
                          className="acdQueuetable"
                          search
                          data={acdQueueData}
                          sortField="Name"
                        />
                      </div>
                    </MDBTabsPane> */}
                  </MDBTabsContent>
                </div>
              </div>
            </section>
            {successMessage && (
              <>
                <TopSuccess>
                  <TopMessage successMessage={successMessage} />
                </TopSuccess>
              </>
            )}
            {errorMessage && (
              <MDBAlert
                open
                className="alert-center"
                color="danger"
                autohide
                position="bottom-right"
                delay={10000}
              >
                <i className="fas fa-times-circle me-3"></i>
                <span className="alert-msg">{errorMessage}</span>
              </MDBAlert>
            )}
            {internalError && (
              <MDBAlert
                open
                className="alert-center"
                color="danger"
                autohide
                position="bottom-right"
                delay={5000}
                onClose={() => setInternalError(false)}
              >
                Internal Server Error
              </MDBAlert>
            )}

            {showExportWarning && (
                    <ImportProgressWarning
                      warningToggle={exportwarningToggle}
                      setShowWarning={setShowExportWarning}
                      onOk={exportwarningToggle}
                      message={warningMessage}
                    />
                  )}

            {showImpExpRedirect && (
              <ImpExpRedirectPopup
                onProceed={() => {
                  setShowImpExpRedirect(false);
                  setfirstRequest(true);
                  importuserToggle();
                }}
                onCancel={() => setShowImpExpRedirect(false)}
              />
            )}

            <MDBModal open={importUser} onClose={() => setimportUser(false)} tabIndex='-1'>
              <MDBModalDialog size="fullscreen">
                <MDBModalContent>
                  <MDBModalHeader>
                    <MDBModalTitle>Import User Template</MDBModalTitle>
                  </MDBModalHeader>
                  <MDBModalBody className="pb-0">
                    <ImportUser
                      onClose={importuserToggle}
                      setIsloading={setIsloading}
                      onShow={setimportUser}
                      show={importUser}
                      firstRequest={firstRequest}
                      setfirstRequest={setfirstRequest}
                    />
                  </MDBModalBody>
                </MDBModalContent>
              </MDBModalDialog>
            </MDBModal>
          </>
        }
      />
      <Tooltip
        anchorSelect=".EditProfile"
        place="top"
        className="exampleTooltip"
      >
        Edit Profile
      </Tooltip>
      <Tooltip
        anchorSelect=".RemoveProfile"
        place="top"
        className="exampleTooltip"
      >
        Remove Profile
      </Tooltip>

      {/* {adduser && (
        <PopupLoader
          title={"Alert"}
          content={<UserUpdateWarnings
             onClose={toggleOpen}
            setHasPrevilege={setHasPrevilege}
            setErrorMessage={setErrorMessage}
            groupInfo={props?.groupInfo ?? null}
            locUser={props?.locUsers ?? null}
          />}
          onShow={setBasicModal}
          onClose={toggleOpen}
        />
      )} */}

      <MDBModal
        open={basicModal}
        onClose={() => setBasicModal(false)}
        tabIndex="-1"
      >
        <MDBModalDialog size="lg">
          <MDBModalContent>
            <MDBModalHeader>
              <MDBModalTitle>Alert</MDBModalTitle>
              <MDBBtn
                className="btn-close"
                color="none"
                onClick={toggleOpen}
              ></MDBBtn>
            </MDBModalHeader>
            <UserUpdateWarnings
              onClose={toggleOpen}
              warningsList={warningsList}
              modifiedDataJSon={modifiedDataJSon}
              sendAPIRequest={sendAPIRequest}
            />
          </MDBModalContent>
        </MDBModalDialog>
      </MDBModal>

      {showWarning && (
        <EditWarning
          warningToggle={warningToggle}
          setShowWarning={setShowWarning}
          onOk={handleOk}
        />
      )}
    </>
  );
}
